module.exports = __webpack_public_path__ + "static/img/company.c178468.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/company.png
// module id = abfB
// module chunks = 0